module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-friesland-black.svg?76b69e53e591fef4d2ad98dc992304fb";